<script lang="ts">
  import { fade } from "svelte/transition"

  export let app_banner: string = null

  let visible = true

  function close(): void {
    visible = false
  }
</script>

{#if visible && app_banner}
  <div
    transition:fade
    id="app-banner"
    class="flex items-center gap-x-6 bg-lwp-blue px-6 py-2.5 sm:px-3.5 sm:before:flex-1 border-t-2 border-b border-black"
  >
    <div class="text-sm leading-6 text-white ProseMirror">
      {@html app_banner}
    </div>
    <div class="flex flex-1 justify-end">
      <button
        type="button"
        class="-m-3 p-3"
        on:click={close}
      >
        <span class="sr-only">Dismiss</span>
        <svg
          class="h-5 w-5 text-white"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
          />
        </svg>
      </button>
    </div>
  </div>
{/if}
